import AxiosConfig from "./AxiosConfig";
import Routing from "./routing";
import DateService from "./DateService";

const getSeancesPlanningLocal = async (userId) => {
    return new Promise((resolve, reject) => {
        const myEventsList = JSON.parse(localStorage.getItem('seancesData'));
        if (myEventsList) {
            // Parse les dates
            myEventsList.forEach(event => {
                event.startDate = new Date(event.startDate);
                event.endDate = new Date(event.endDate);
                event.userHasRegistered = 1; // Todo determiner si la seance est dispo ou enregistrée pour l'user
                event.link = Routing.generate({route: Routing.routes.seance, params: {id: event.id}});
                event.date = event.startDate;
            });

            const legend = [
                {
                    label: "Séances disponibles",
                    color: "#7A9A01"
                },
                {
                    label: "Mes séances enregistrées",
                    color: "#004851"
                }
            ];
            resolve({
                events: myEventsList,
                legend: legend
            });
        }
    });
};

const getSeancesPlanningApi = async (start = null, end = null) => {
    // S'assurer que les dates sont YYYY-MM-DD
    // Vérifier si les dates sont déjà au bon format
    if (start) {
        if (!DateService.isValidUniversalDate(start)) {
            try {
                start = DateService.convertFrenchDateToIso(start);
            } catch (error) {
                console.error('start: ', start);
            }
        }
    }

    if (end) {
        if (!DateService.isValidUniversalDate(end)) {
            try {
                end = DateService.convertFrenchDateToIso(end);
            } catch (error) {
                console.error('end: ', end);
            }
        }
    }

    try {
        const response = await AxiosConfig.get(Routing.generate({route: Routing.routesApi.seancesPlanning, params: {start, end}}));
        return response.data;
    } catch (error) {
        console.error('error: ', error);
        throw error;
    }
};


const parseSeancesPlanning = (
    seances,
    legend = [
        { label: "Séances disponibles", color: "#7A9A01"},
        {label: "Mes séances à venir", color: "#004851"},
        {label: "Séances en attente", color: "#dab70b"},
    ]) => {
    if (seances && seances.length > 0 ) {
        // Parse les dates
        seances.forEach(seance => {
            seance.startDate = new Date(seance.startDate);
            seance.endDate = new Date(seance.endDate);
            seance.userHasRegistered = seance.userRegistered;
            seance.link = Routing.generate({route: Routing.routes.seance, params: {id: seance.id}});
            seance.date = seance.startDate;
            seance.style = {
                backgroundColor: new Date(seance.heure_debut) < new Date() ? "#b1b1b1" : seance.userRegistered ? seance.file_attente ? "#dab70b" : "#004851" : "#7A9A01"
                // backgroundColor: seance.userRegistered ? "#004851" : "#7A9A01"
            };
        });
    }

    return {
        events: seances,
        legend: legend
    };
};

const colorSeance = {
    actif: "#7A9A01",
    inactif: "#c2b200",
    coach_absent: "#ff0000",
}


const parseSeancesPlanningAdmin = (seances) => {
    if (seances && seances.length > 0 ) {
        seances.forEach(seance => {
            seance.startDate = new Date(seance.startDate);
            seance.endDate = new Date(seance.endDate);
            seance.userHasRegistered = seance.userRegistered;
            seance.link = Routing.generate({route: Routing.routes.seance, params: { id: seance.id }});
            seance.date = seance.startDate;
            seance.style = {
                backgroundColor: (seance.actif ? (seance.coach.absent ? colorSeance.coach_absent : colorSeance.actif) : colorSeance.inactif),
            };
        });
    }

    return {
        events: seances,
        legend: [
            {
                label: "Active",
                color: colorSeance.actif
            },
            // {
            //     label: "Inactive",
            //     color: colorSeance.inactif
            // },
            {
                label: "Coach absent",
                color: colorSeance.coach_absent
            }
        ]
    };
}

const parseSeancesPlanningCoach = (seances, legend = [{ label: "Séances disponibles", color: "#7A9A01"}, {label: "Mes séances enregistrées", color: "#004851"}]) => {
    if (seances && seances.length > 0 ) {
        // Parse les dates
        seances.forEach(seance => {
            seance.startDate = new Date(seance.startDate);
            seance.endDate = new Date(seance.endDate);
            seance.userHasRegistered = seance.userRegistered;
            seance.link = Routing.generate({route: Routing.routes.seance, params: { id: seance.id }});
            seance.date = seance.startDate;
            seance.style = {
                backgroundColor: seance.startDate < new Date() ? "#004851" : "#7A9A01"
            };
        });
    }

    return {
        events: seances,
        legend: legend
    };
};


export { getSeancesPlanningLocal, getSeancesPlanningApi, parseSeancesPlanning, parseSeancesPlanningAdmin, parseSeancesPlanningCoach};
